<template>
  <ais-pagination show-last>
    <template
      v-slot="{
              currentRefinement,
              nbPages,
              pages,
              isFirstPage,
              isLastPage,
              refine,
              createURL
            }"
    >
      <ul :class="{ 'd-none': pages <= 1 }" class="pagination">
        <li
          class="page-item"
          :class="{
              disabled: isFirstPage,
            }"
        >
          <a
            v-if="!isFirstPage"
            class="page-link"
            :href="createURL(currentRefinement - 1)"
            @click.prevent="refine(currentRefinement - 1); $emit('click')"
          >
            ‹
          </a>
          <a
            v-if="isFirstPage"
            class="page-link"
          >
            ‹
          </a>
        </li>
        <li
          :class="{
              active: page === currentRefinement
            }"
          class="page-item"
          v-for="page in pages"
          :key="page"
        >
          <a
            class="page-link"
            :href="createURL(page)"
            @click.prevent="refine(page); $emit('click')"
          >
            {{ page + 1 }}
          </a>
        </li>
        <li class="page-item" v-if="!isLastPage">
          <a
            class="page-link"
            :href="createURL(currentRefinement + 1)"
            @click.prevent="refine(currentRefinement + 1); $emit('click')"
          >
            ›
          </a>
        </li>
      </ul>
    </template>
  </ais-pagination>
</template>

<script>
export default {
  name: "StyledSearchNavigation",
}
</script>

<style scoped>

</style>
